import { render } from "./SupplierModal.vue?vue&type=template&id=526d48d0&scoped=true"
import script from "./SupplierModal.vue?vue&type=script&lang=js"
export * from "./SupplierModal.vue?vue&type=script&lang=js"

import "./SupplierModal.vue?vue&type=style&index=0&id=526d48d0&lang=stylus&scoped=true"
import "./SupplierModal.vue?vue&type=style&index=1&id=526d48d0&lang=stylus"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-526d48d0"]])

export default __exports__